module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch14"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch14aa"
    }
  }), _c('a', {
    attrs: {
      "id": "ch14a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch14"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("FLUBBED HEADLINES")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("Whether silly, naughty, or just plain bizarre, they’re all real.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("Climber Who Cut Off Arm to Escape Speaking at MSU")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICTURES FROM UNDERCOVER")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOTERS BUST RELEASED")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('b', [_vm._v("Farm Bureau Estimates Crap Damage at $207 Million")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_vm._v("Garbage truck lands on Saturn")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("Pedestrian deaths largely flat in U.S., Maryland")])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("New President at Kansas City Fed")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NMARRIED")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUPLES")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IND")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVORCE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFICULT")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("Padres pitcher Latos writes ‘I hate SF’ on balls")])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("Four More Newspapers Switch to Offset; Conversions Not Always Soomth")])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("6-year-old girl just found after 26 years")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_vm._v("1 in 5 U.S. moms have babies with multiple dads, study says")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('b', [_vm._v("Marijuana Supporters at Record High")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("A-Rod Gets Hit, Colon hurt")])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_vm._v("Bugs Flying Around with Wings Are Flying Bugs")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('b', [_vm._v("For Towns Hold Elections")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('b', [_vm._v("Northfield Plans to Plan Strategic Plan")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_vm._v("Troutt named to Salmon Board")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISHOPS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GREE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EX")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BUSE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULES")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("Former Jets reflect on impact of 9/11 attacks")])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("Every Students Counts")])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("Woman accused of mugging a man using a walker")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('b', [_vm._v("150th Year for Dead and Blind Institute")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_c('i', [_c('b', [_vm._v("Obama to Recruit Clinton’s Top Fun Raisers")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("Church member donates organ to St. Aloysius")])]), _vm._v(" "), _c('p', {
    staticClass: "center2z"
  }, [_c('span', [_vm._v("Texans Support Death Penalty, but Only for the Guilty")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("The average U.S. household has about 40 electric motors.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c27c92c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter014.vue
// module id = 120
// module chunks = 0